import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  registerVeiculoRequest: ['veiculo'],
  registerVeiculoSuccess: null,

  updateVeiculoRequest: ['veiculo', 'values'],
  updateVeiculoSuccess: null,

  getAllVeiculoRequest: null,
  getAllVeiculoSuccess: ['veiculos'],

  deleteVeiculoRequest: ['id'],
  deleteVeiculoSuccess: null,

  requestVeiculoFailure: ['error'],
});

const INITIAL_STATE = { veiculos: [], loading: false, error: '' };

/**
 * REGISTER REQUESTS BELLOW
 */

const registerVeiculoRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const registerVeiculoSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * UPDATE REQUESTS BELLOW
 */

const deleteVeiculoRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const deleteVeiculoSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});
/**
 * UPDATE REQUESTS BELLOW
 */

const updateVeiculoRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const updateVeiculoSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * GET SERVICES
 */

const getAllVeiculoRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
  veiculos: [],
});

const getAllVeiculoSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  error: '',
  loading: false,
  veiculos: action.veiculos,
});

/**
 * Request falure
 */
const requestVeiculoFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  error: action.error,
  loading: false,
});

export default createReducer(INITIAL_STATE, {
  [Types.REGISTER_VEICULO_REQUEST]: registerVeiculoRequest,
  [Types.REGISTER_VEICULO_SUCCESS]: registerVeiculoSuccess,

  [Types.REQUEST_VEICULO_FAILURE]: requestVeiculoFailure,

  [Types.UPDATE_VEICULO_REQUEST]: updateVeiculoRequest,
  [Types.UPDATE_VEICULO_SUCCESS]: updateVeiculoSuccess,

  [Types.DELETE_VEICULO_REQUEST]: deleteVeiculoRequest,
  [Types.DELETE_VEICULO_SUCCESS]: deleteVeiculoSuccess,

  [Types.GET_ALL_VEICULO_REQUEST]: getAllVeiculoRequest,
  [Types.GET_ALL_VEICULO_SUCCESS]: getAllVeiculoSuccess,
});
